import * as React from "react";
import { motion } from "framer-motion";

const container = {
	initial: {},
	show: {},
};

const pathGrey = {
	initial: {
		fill: "rgba(255,255,255, .2)",
	},
	show: {
		fill: "#ECECEC",
		transition: { duration: 1 },
	},
};

const pathWhite = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#FFFFFF",
		transition: { duration: 1 },
	},
};

const pathBlue = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#293E61",
		transition: { duration: 1 },
	},
};
const pathOtherBlue = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#293F61",
		transition: { duration: 1 },
	},
};
const pathOrange = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		fill: "#F4B336",
		transition: { duration: 1 },
	},
};

const strokeBlue = {
	initial: {
		fill: "rgba(255, 255, 255, 0.2)",
	},
	show: {
		stroke: "#293E61",
		transition: { duration: 1 },
	},
};

function ArchBrand(props) {
	return (
		<motion.svg
			variants={container}
			initial="initial"
			animate={props.isHovered ? "show" : {}}
			whileHover="show"
			width={156}
			height={156}
			viewBox="0 0 156 156"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<motion.path
				variants={pathGrey}
				d="M150.509 77.903l-72.583 72.589-72.59-72.588L77.926 5.32l72.583 72.583z"
				fill="rgba(255,255,255, .2)"
			/>
			<motion.path
				variants={strokeBlue}
				d="M152.912 77.958l-74.959 74.958L3 77.958 77.953 3l74.959 74.958z"
				stroke="rgba(255, 255, 255, 0.2)"
				strokeWidth={4}
				strokeMiterlimit={10}
				strokeLinecap="round"
			/>
			<motion.path
				variants={pathOtherBlue}
				d="M115.592 58.025h-.244L95.804 38.21 75.01 58.025h-2.919l12.424-12.019-1.27-2.502-14.565 14.521h-1.984L82.603 42.4l-.95-1.965-18.426 17.591h-3.066l10.125-9.902-1.305-2.653-12.25 12.555h-1.899l13.507-13.66-.955-1.966-16.035 15.626h-2.752l8.809-9.064-1.19-2.444-11.043 11.508h-1.925l12.33-12.61-.955-1.97-14.85 14.58h-7.898"
				fill="rgba(255, 255, 255, 0.2)"
			/>
			<motion.path
				variants={pathBlue}
				d="M10.8 77.925l19.531-19.992h94.876l19.775 19.776-18.023 17.986-98.354.027s-17.33-17.32-17.804-17.797z"
				fill="rgba(255, 255, 255, 0.2)"
			/>
			<motion.path
				variants={pathOrange}
				d="M31.582 98.674l92.559-.036-46.206 46.468-46.353-46.432z"
				fill="rgba(255,255,255, 0.2)"
			/>
			<motion.path
				variants={pathWhite}
				d="M43.604 70.936l-3.044 8.226h6.026l-2.982-8.226zm6.43 17.561l-1.86-4.702h-9.273l-1.757 4.702h-6.296L40.9 64.543h5.614l9.947 23.954h-6.429zM70.2 71.886c0-.564-.12-1.02-.355-1.37a2.454 2.454 0 00-.918-.814 4.162 4.162 0 00-1.261-.39 9.455 9.455 0 00-1.34-.102h-3.092v5.587h2.751c.475 0 .963-.04 1.464-.12.497-.08.95-.218 1.358-.422a2.582 2.582 0 001.003-.883c.261-.381.39-.878.39-1.486zm.24 16.612l-5.205-9.508h-1.97v9.508h-5.652V64.542h9.14c1.145 0 2.267.12 3.362.355 1.097.24 2.078.639 2.947 1.203a6.298 6.298 0 012.076 2.232c.52.928.782 2.076.782 3.45 0 1.625-.445 2.992-1.323 4.097-.879 1.105-2.095 1.895-3.652 2.37l6.26 10.249H70.44zM95.677 88.075c-1.556.71-3.349 1.066-5.377 1.066-1.85 0-3.563-.307-5.13-.915-1.566-.608-2.922-1.47-4.072-2.587-1.155-1.118-2.054-2.454-2.708-4.011-.655-1.557-.984-3.27-.984-5.142 0-1.917.333-3.656.999-5.21.665-1.556 1.583-2.883 2.758-3.975 1.173-1.095 2.549-1.934 4.128-2.52 1.58-.59 3.278-.883 5.112-.883 1.684 0 3.35.302 4.991.897 1.633.599 2.959 1.473 3.97 2.622l-3.925 3.926a4.847 4.847 0 00-2.131-1.658 7.083 7.083 0 00-2.706-.542c-1.016 0-1.944.186-2.787.559a6.521 6.521 0 00-2.187 1.54 7.066 7.066 0 00-1.42 2.32c-.337.887-.505 1.863-.505 2.924 0 1.082.168 2.076.505 2.977a6.975 6.975 0 001.403 2.321 6.333 6.333 0 002.15 1.504c.831.359 1.745.541 2.738.541 1.155 0 2.152-.226 3.014-.68.855-.447 1.543-1.033 2.067-1.756l4.025 3.79c-1.06 1.22-2.37 2.183-3.928 2.892zM116.349 88.497V78.483h-9.336v10.014h-5.786V64.543h5.786v9.068h9.336v-9.069h5.789v23.955h-5.789z"
				fill="rgba(255, 255, 255, 0.2)"
			/>
			<motion.path
				variants={pathBlue}
				d="M82.903 130.17c0 .87-.15 1.62-.462 2.254a4.542 4.542 0 01-1.229 1.571c-.514.412-1.1.724-1.748.933a6.834 6.834 0 01-2.022.309 6.547 6.547 0 01-1.838-.253 5.908 5.908 0 01-1.58-.71 4.826 4.826 0 01-1.22-1.131 4.476 4.476 0 01-.75-1.509l3.062-.944c.146.497.426.9.834 1.224.404.32.888.48 1.451.48.572 0 1.07-.174 1.49-.52.418-.35.627-.865.627-1.544 0-.412-.084-.759-.257-1.042a2.024 2.024 0 00-.67-.67 2.883 2.883 0 00-.933-.351 5.983 5.983 0 00-1.041-.098c-.507 0-1.084.058-1.732.17a9.759 9.759 0 00-1.73.452l.342-8.111h8.687v2.884h-5.706l-.123 2.246c.217-.059.451-.094.713-.112a8.38 8.38 0 01.71-.031c.71 0 1.376.093 2.001.28.63.185 1.176.47 1.633.851.462.382.825.852 1.092 1.412.266.558.4 1.216.4 1.96zM63.526 106.949a3.1 3.1 0 00-1.154-.893c-.47-.218-.931-.328-1.366-.328-.231 0-.462.018-.696.058-.232.04-.44.12-.627.23a1.57 1.57 0 00-.474.439 1.206 1.206 0 00-.192.692c0 .241.054.44.157.6.096.159.244.302.434.422.196.119.426.23.692.332.266.098.568.204.906.306.479.164.976.342 1.495.532.523.195.998.453 1.424.769.427.323.78.723 1.06 1.193.28.475.421 1.065.421 1.77 0 .816-.15 1.522-.451 2.112a4.167 4.167 0 01-1.208 1.473 5.185 5.185 0 01-1.744.861c-.652.186-1.33.28-2.022.28a8.418 8.418 0 01-2.941-.529c-.951-.354-1.736-.86-2.361-1.513l2.24-2.28c.345.426.803.78 1.371 1.069.568.288 1.131.43 1.691.43.256 0 .501-.026.74-.079.24-.054.453-.142.636-.262.177-.119.318-.28.425-.478.111-.201.16-.44.16-.724 0-.267-.066-.494-.195-.679a2.091 2.091 0 00-.573-.51 4.605 4.605 0 00-.923-.418 39.045 39.045 0 00-1.251-.412c-.453-.147-.897-.32-1.331-.52a4.423 4.423 0 01-1.159-.771 3.56 3.56 0 01-.825-1.141c-.207-.448-.31-.994-.31-1.632 0-.786.164-1.46.48-2.024a4.18 4.18 0 011.264-1.38 5.498 5.498 0 011.76-.79 7.942 7.942 0 011.98-.253 7.38 7.38 0 012.454.444 6.273 6.273 0 012.191 1.3l-2.178 2.304zM72.875 107.047l-1.801 4.863h3.563l-1.762-4.863zm3.803 10.388l-1.1-2.783h-5.485l-1.038 2.783h-3.727l5.95-14.172h3.318l5.888 14.172h-3.806zM84.643 106.185v2.923h5.48v2.823h-5.48v5.506h-3.385v-14.176h9.33v2.924h-5.945zM98.678 111.311c0-.523-.165-.967-.488-1.339-.333-.377-.821-.565-1.472-.565-.325 0-.614.055-.884.152a2.365 2.365 0 00-.702.413c-.2.172-.359.377-.479.607-.119.236-.186.48-.198.732h4.223zm3.026 1.261v.403c0 .129-.009.257-.022.377h-7.227c.026.28.11.538.248.758.14.232.323.427.545.595a2.617 2.617 0 001.588.529c.519 0 .963-.098 1.323-.289.36-.195.652-.443.878-.754l2.285 1.446a4.63 4.63 0 01-1.855 1.571c-.768.364-1.654.551-2.67.551-.75 0-1.456-.121-2.121-.351a5.113 5.113 0 01-1.753-1.021 4.66 4.66 0 01-1.18-1.654c-.288-.653-.43-1.398-.43-2.241 0-.813.137-1.549.421-2.21a4.974 4.974 0 011.136-1.681 5.186 5.186 0 011.704-1.074 5.828 5.828 0 012.125-.378c.733 0 1.407.12 2.018.368a4.409 4.409 0 011.58 1.07c.444.47.786 1.038 1.034 1.704.244.665.373 1.428.373 2.281zM103.022 106.808a.82.82 0 00.341-.071c.111-.04.165-.133.165-.276 0-.124-.05-.208-.147-.252a.757.757 0 00-.315-.062h-.381v.661h.337zm-.755-1.017h.821c.107 0 .209.014.316.035a.889.889 0 01.274.12c.08.054.147.125.196.21.049.084.07.19.07.314a.594.594 0 01-.142.413.708.708 0 01-.389.213l.625 1.015h-.51l-.546-.967h-.297v.967h-.418v-2.32zm-.931 1.172c0 .235.044.457.133.669.093.209.217.396.373.56.159.159.346.284.554.372.209.094.439.138.679.138.24 0 .466-.044.68-.138.211-.088.398-.213.553-.372.157-.164.285-.351.373-.56.093-.212.133-.434.133-.669a1.7 1.7 0 00-.506-1.233 1.632 1.632 0 00-.553-.373 1.681 1.681 0 00-.68-.134 1.708 1.708 0 00-1.233.507 1.8 1.8 0 00-.373.55 1.747 1.747 0 00-.133.683zm-.328 0c0-.284.057-.551.163-.804.107-.253.258-.47.448-.651a2.034 2.034 0 011.456-.604 2.021 2.021 0 011.46.604c.187.181.337.398.443.651.112.253.168.52.168.804 0 .284-.056.549-.168.794a2.01 2.01 0 01-1.099 1.083 2.041 2.041 0 01-1.607 0 1.998 1.998 0 01-.653-.431 1.992 1.992 0 01-.448-.652 1.981 1.981 0 01-.163-.794z"
				fill="rgba(255, 255, 255, 0.2)"
			/>
		</motion.svg>
	);
}

export default ArchBrand;
